import { Info } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

export default function CustomLaneHeader({ title, label, description, status, setLeadStatusData, setLeadStatusDescriptionViewModal }) {
    return (
        <div className="laneTitleWrapper">
            <Tooltip title="View Description" style={{ padding: 0, margin: 0 }}>
                <button
                    onClick={() => {
                        setLeadStatusData({ name: title, description, status });
                        setLeadStatusDescriptionViewModal(true);
                    }}
                    style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                >
                    <IconButton className="laneViewBtn">
                        <Info style={{ height: "20px", width: "20px", color: "#6e6e6e" }} />
                    </IconButton>
                </button>
            </Tooltip>
            <span className="leadStatusName">{title}</span>
            <span className="leadStatusCounter">{label}</span>
        </div>
    );
};